<script>
  import { SPRITES } from "../../../constants/sprites";
  import {
    GameStateStore,
    ItemsStore,
    SetupStore,
    PlayersStore,
  } from "../../stores/gameStore";
  import Card from "../Card.svelte";
  import Component from "../Component.svelte";
  import CraftingTableItem from "./CraftingTableItem.svelte";
  import PotionsPile from "../PotionsPile.svelte";
  // import ItemCard from "./ItemCard.svelte";

  export let id, scale, selectableCards, action;

  $: tile = $SetupStore?.data?.craftingBoards?.[id];
</script>

{#if tile}
  <div
    style:margin-left={id === "A" ? undefined : `-${80 * scale}px`}
    class="tile"
  >
    <Component
      width={tile.size[0] * scale}
      sprite={{
        width: tile.size[0],
        height: tile.size[1],
        class: "CRAFTING_TABLE",
      }}
      fullWidth={SPRITES.CRAFTING_TABLE.fullWidth}
      offset={tile.offset}
    />

    {#each tile.slots as slot}
      <div
        class="slot"
        id={''.concat(slot.cardId, '_craftingtree')}
        style:left="{slot.offset[0] * scale}px"
        style:top="{slot.offset[1] * scale}px"
        style:width="{SPRITES["ITEMS_FRONT"].width * scale * 0.5}px"
        style:height="{SPRITES["ITEMS_FRONT"].height * scale * 0.5}px"
      >
        {#if $ItemsStore[slot.cardId]?.card_location != "CRAFTINGTREE"}
          <p 
            class="player-name" 
            style="color: #{$PlayersStore[$ItemsStore[slot.cardId]?.card_location]?.color};"
          >
            {$PlayersStore[$ItemsStore[slot.cardId]?.card_location]?.name}
          </p>
        {/if}
        {#if $ItemsStore[slot.cardId]?.card_location === "CRAFTINGTREE"}
          <CraftingTableItem
            id={slot.cardId}
            {action}
            {scale}
            disabled={selectableCards &&
              !selectableCards?.includes(slot.cardId)}
            selectable={selectableCards?.includes(slot.cardId)}
          />
        {/if}
      </div>
    {/each}

    {#if id === "G"}
      <div
      style="position:absolute; z-index: 10;"
      >
        <PotionsPile
          scale= {scale}
          left= {410 * scale}
          top= {-232 * scale}
        />
      </div>
    {/if}

  </div>
{/if}

<style>
  .slot {
    position: absolute;
  }

  .tile {
    position: relative;
    pointer-events: none;
  }

  .tile > * {
    pointer-events: all;
  }

  .player-name {
    font-size: 10px;
    width: 73px;
    font-weight: bold;
    text-align: center;
    margin: 0;
    color: inherit; /* Use the inline style for dynamic colors */
    background-color: rgba(255, 255, 255, 0.75);
    padding: 2px 5px;
    border-radius: 10px;
    display: inline-block;
    pointer-events: none;

    white-space: nowrap; /* Prevent text wrapping */
    overflow: hidden; /* Hide overflow text */
    text-overflow: ellipsis; /* Add "..." for overflow text */
  }
</style>
